var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSvg && _vm.isCorsSafe)?_c('svg',{style:(("width:22vw; height:22vw; fill:" + _vm.iconColor + "; stroke:#fff; stroke-width: 8px;")),attrs:{"data-src":_vm.source.Logo + '#Content'}}):_c('img',{style:({
    maxWidth: '22vw',
    height: '22vw',
    filter: ("invert(" + (_vm.$vuetify.theme.dark ? 1 : 0) + ")"),
  }),attrs:{"src":_vm.source.Logo,"alt":_vm.source.Name}})}
var staticRenderFns = []

export { render, staticRenderFns }